/**
 * The floor the create mutations hold themselves to.
 *
 * Long enough that the provisioning status reads as work rather than as a glitch
 * that leaves the reader unsure whether anything happened.
 */
export const MINIMUM_PROVISIONING_MS = 2000

/**
 * Resolves no earlier than `minimumMs`, however fast the work itself was.
 *
 * For progress that is worth seeing: a status that appears and vanishes within a
 * few hundred milliseconds reads as a glitch rather than as work, and the reader
 * is left unsure whether anything happened. Slower work is never padded — the
 * floor only ever absorbs the gap.
 *
 * A rejection is **not** held back. There is no transition to smooth over when
 * the work failed, and delaying the report would only delay the retry.
 */
export const withMinimumDuration = async <T>(
  work: Promise<T>,
  minimumMs: number
): Promise<T> => {
  const floor = new Promise((resolve) => setTimeout(resolve, minimumMs))
  const [result] = await Promise.all([work, floor])
  return result
}
